import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#04838C",
      d: "M2.978 7.56H0l.198-1.407L20.002 0l19.674 6.006L40 7.135l-2.975.425V23H2.978V7.56Zm10.578 1.716L6.76 10.628v5.855l6.796 1.325V9.276Zm10.578 0H15.87v8.532h8.264V9.276Zm9.255 7.207V10.82l-6.942-1.544v8.532l6.942-1.325Z"
    }, null, -1)
  ])))
}
export default { render: render }